import { itwApi } from '../middlewares/api';
const fetchIncidnets = async (data) => {
    const response = await itwApi.post('Incident/get-mobile-incident-detail', data);
    return response.data;
};
const fetchIncidnetsPreviewDetail = async (id) => {
    const response = await itwApi.get('Incident/get-preview-for-incident-detail', {
        params: { id }
    });
    return response.data;
};
const fetchIncidentsPreviewHistory = async (data) => {
    const response = await itwApi.post('Incident/get-mobile-incident-preview', data);
    return response.data;
};
const getIncidentAlerts = async () => {
    var response = await itwApi.get(`incident/get-alerts`);
    return response.data;
};
const updateIncidentAlerts = async (id) => {
    const response = await itwApi.put(`/incident/${id}`);
    return response.data;
};
const incidentsApi = {
    fetchIncidnets,
    fetchIncidnetsPreviewDetail,
    fetchIncidentsPreviewHistory, getIncidentAlerts, updateIncidentAlerts
};
export default incidentsApi;
